"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeamMemberSolid: function() {
        return TeamMemberSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const TeamMemberSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M3.00006 5C3.00006 3.34315 4.3432 2 6.00006 2C7.65691 2 9.00006 3.34315 9.00006 5C9.00006 6.65685 7.65691 8 6.00006 8C4.3432 8 3.00006 6.65685 3.00006 5Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.9992 17C9.2798 17 6.87767 18.3578 5.43372 20.4279C5.11776 20.8809 5.22883 21.5042 5.68181 21.8202C6.13478 22.1361 6.75813 22.0251 7.07409 21.5721C8.16004 20.0152 9.96114 19 11.9992 19C14.0373 19 15.8384 20.0152 16.9243 21.5721C17.2403 22.0251 17.8636 22.1361 18.3166 21.8202C18.7696 21.5042 18.8807 20.8809 18.5647 20.4279C17.1208 18.3578 14.7186 17 11.9992 17Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M1.20056 11.3988C2.29355 9.94409 4.03669 9 6.00006 9C6.55234 9 7.00006 9.44772 7.00006 10C7.00006 10.5523 6.55234 11 6.00006 11C4.69222 11 3.53103 11.6266 2.79955 12.6002C2.46781 13.0417 1.84093 13.1307 1.39938 12.799C0.957835 12.4673 0.868821 11.8404 1.20056 11.3988Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M18.0001 9C17.4478 9 17.0001 9.44772 17.0001 10C17.0001 10.5523 17.4478 11 18.0001 11C19.3081 11 20.4694 11.6268 21.2009 12.6006C21.5325 13.0422 22.1594 13.1313 22.601 12.7996C23.0426 12.4679 23.1317 11.841 22.8 11.3994C21.707 9.94434 19.9637 9 18.0001 9Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M18.0001 2C16.3432 2 15.0001 3.34315 15.0001 5C15.0001 6.65685 16.3432 8 18.0001 8C19.6569 8 21.0001 6.65685 21.0001 5C21.0001 3.34315 19.6569 2 18.0001 2Z",
            fill: "currentColor"
        })
    ]
}), "TeamMemberSolid");
const _default = TeamMemberSolid;
